module.exports = __webpack_public_path__ + "img/12-live-auth.271954e2.png";